import Flatpickr from 'react-flatpickr';
import { InterruptionsByEmployeePortal } from '../../../../common/components/selectors/interruption/InterruptionsByEmployeePortal';
import { SchedulingChangeRequestsRequest } from '../../../../models/employees-portal/CreateSchedulingRequest';
import { AppContext } from '../../../../common';
import { useDropzone } from 'react-dropzone';
import { useCallback, useContext } from 'react';
import { documentValidationRules } from '../../../../utils/documentValidationrules';

interface Props {
    handleInputInterruption: (name: string, value: any) => void;
    request: SchedulingChangeRequestsRequest;
    handlerSetWholeDay: (value: boolean, interruptionId?: number) => void;
    isDateLocked?: boolean;
}

export const InterruptionRequestModal = ({
    handleInputInterruption,
    request,
    handlerSetWholeDay,
    isDateLocked = false,
}: Props) => {
    const { langResources } = useContext(AppContext);

    const validationDocument = (file: File): string | undefined => {
        const validationRules = documentValidationRules.document;

        if (!validationRules) {
            return 'Tipo de documento no válido.';
        }
        // Validar el tipo de archivo
        if (!validationRules.allowedFormats.includes(file.type)) {
            return `Formato no permitido. Los formatos permitidos son: ${validationRules.message}`;
        }

        // Validar el tamaño del archivo
        const maxSizeInBytes = validationRules.maxSizeMB * 1024 * 1024;

        if (file.size > maxSizeInBytes) {
            return `El archivo excede el tamaño máximo permitido de ${validationRules.maxSizeMB} MB.`;
        }
    };

    const onDrop = useCallback(
        (acceptedFiles: File[]) => {
            if (acceptedFiles.length > 0) {
                let file = acceptedFiles[0];

                if (file) {
                    let error = validationDocument(file);

                    if (error && error.length > 0) {
                        alert(error);
                        return;
                    } else {
                        handleInputInterruption('file', file);
                    }
                }
            }
        },
        [handleInputInterruption]
    );

    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        onDrop,
        maxFiles: 1,
    });

    return (
        <div>
            <h5>Permisos</h5>
            <div className='row g-3 align-items-center mb-3 w-100'>
                <div className='col-12 col-lg-4'>
                    <label className='form-label' htmlFor=''>
                        Fecha *
                    </label>

                    <div className=''>
                        <input
                            type='date'
                            name=''
                            className='form-control'
                            id=''
                            disabled={isDateLocked}
                            onChange={(e) =>
                                handleInputInterruption('date', e.target.value)
                            }
                            value={request?.interruptionRequest.date.split('T')[0]}
                        />
                    </div>
                </div>

                <div className='col-12 col-lg-4'>
                    <label className='form-label' htmlFor=''>
                        Hora Inicio/Hora Final *
                    </label>

                    <div className='d-flex w-100'>
                        <Flatpickr
                            className='form-control text-black '
                            value={request?.interruptionRequest.startHour}
                            onChange={(e) =>
                                handleInputInterruption(
                                    'startHour',
                                    e[0].toString().split(' ')[4]
                                )
                            }
                            options={{
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: 'H:i',
                            }}
                            disabled={request.interruptionRequest.isFullDay}
                        />
                        <Flatpickr
                            className='form-control text-black '
                            value={request?.interruptionRequest.endHour}
                            onChange={(e) =>
                                handleInputInterruption(
                                    'endHour',
                                    e[0].toString().split(' ')[4]
                                )
                            }
                            options={{
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: 'H:i',
                            }}
                            disabled={request.interruptionRequest.isFullDay}
                        />
                    </div>
                </div>

                <div className='col-12 col-lg-4'>
                    <label className='form-label' htmlFor=''>
                        Seleccionar Permiso *
                    </label>
                    <InterruptionsByEmployeePortal
                        name='interruptionTypeId'
                        onChange={handleInputInterruption}
                        value={request?.interruptionRequest.interruptionTypeId}
                    />
                </div>

                <div className='col-12 col-md-6'>
                    <label className='form-label' htmlFor=''>
                        Escribe el motivo del permiso*
                    </label>

                    <textarea
                        value={request?.interruptionRequest.comments}
                        onChange={(e) =>
                            handleInputInterruption('comments', e.target.value)
                        }
                        className='form-control text-black'
                        name=''
                        id=''
                        cols={10}
                        rows={5}
                    ></textarea>
                </div>

                <div className='col-12 col-md-6'>
                    <label className='form-label' htmlFor=''>
                        Subir permiso
                    </label>
                    <div
                        {...getRootProps({ className: 'dropzone' })}
                        style={{
                            minHeight: 115,
                            zIndex: 999900,
                        }}
                    >
                        <input {...getInputProps()} />
                        <p className='text-center m-0 p-0 text-muted p-1'>
                            Toca aqui o arrastra en este espacio para subir el
                            soporte del permiso{' '}
                            {request?.interruptionRequest?.file?.name}
                        </p>
                    </div>
                </div>

                <div className={`form-check text-start  my-3 checked-custom`}>
                    <input
                        disabled={
                            request.interruptionRequest.interruptionTypeId == 0
                        }
                        className='form-check-input '
                        type='checkbox'
                        id='input-hours-day'
                        checked={request.interruptionRequest.isFullDay}
                        onChange={(e) => {
                            handlerSetWholeDay(
                                !request.interruptionRequest.isFullDay
                            );
                        }}
                    />
                    <label className='form-check-label' htmlFor='input-hours-day'>
                        {
                            langResources['create.interruption.Modal'][
                                'whole.day.label'
                            ]
                        }
                    </label>
                </div>
            </div>
        </div>
    );
};
